import { Component, OnInit } from '@angular/core';
import { FashionLoginComponent } from 'gung-standard';
import { environment } from './../../../environments/environment';

@Component({
    selector: 'tylo-fashion-login',
    templateUrl: './tylo-fashion-login.component.html',
    styleUrls: ['./tylo-fashion-login.component.css'],
    standalone: false
})
export class TyloFashionLoginComponent extends FashionLoginComponent implements OnInit {
  logo: string;
  project: string;

  ngOnInit() {
    super.ngOnInit();
    this.logo = environment.logoName;
    this.project = environment.projectName;
  }
}
